<main class="container-fluid main-order">
  <!--***************************************************************Top Panel*************************************************************************-->
  <p-splitter styleClass="mb-5 sec-h" layout="vertical" [style]="{ 'height': '100%' }" [panelSizes]="[50, 50]">
    
    <ng-template pTemplate>
      @if (searchResults) {
      
        <section class="panel d-flex flex-column h-100" style="min-height: 370px;">
          <div class="row">
            <div class="col-lg-4 padding-box">
              <app-company-dropdown  (companySelection)="comapnySelectionChange($event)"></app-company-dropdown>
            </div>
            <div class="search-group col-lg-6">
             
            </div>
            <div class="col-lg-2">
              
            </div>
          </div>
          <div class="search d-flex justify-content-between">
            <app-search-bar (search)="onSearch($event)" [searchText]="searchText" selected="2"/>
           
              <app-pagination-bar 
              [odin]="false"
                [firstPage]="searchResults.first"
                [lastPage]="searchResults.last"
                [totalElement]="searchResults.numberOfElements"
                [pageSize]="searchResults.size"
                [totalPages]="searchResults.totalPages"
                [totalElements]="searchResults.totalElements"
                [currentPage]="searchResults.number"
                [from]="(searchResults.number*searchResults.size) + 1"
                [to]="(searchResults.number*searchResults.size) + searchResults.numberOfElements"
                (startPage)="doOrderPageSearch(0)"
                (finalPage)="doOrderPageSearch(searchResults.totalPages - 1)"
                (previousPage)="doOrderPageSearch(searchResults.number-1)"
                (nextPage)="doOrderPageSearch(searchResults.number+1)">
              </app-pagination-bar>
          </div>
          @if (rowDataOrder.length > 0) {
            <ag-grid-angular
              class="flex-grow-1 ag-theme-quartz"
              [rowData]="searchResults.content"
              [columnDefs]="colDefsOrder"
              [rowSelection]="rowSelection"
              [gridOptions]="gridOptions"
              (gridReady)="onOrderGridReady($event)"
              (selectionChanged)="onOrderSelectionChanged()"
              (sortChanged)="onSortChanged($event)"
              (modelUpdated)="onModelUpdated($event)">
            </ag-grid-angular>
          } @else {
            <div class="d-flex justify-content-center align-items-center h-100">
              <div class="text-center">
                <img class="mb-2" src="assets/images/no-results-main.svg" alt="Tata Steel logo" />
                <p class="mb-2 text-secondary text-strong">No results found</p>
                <p class="text-secondary" style="max-width: 360px">Try adjusting your search query or switch between coil and order level via the dropdown next to the search bar</p>
              </div>
            </div>
          }
        </section>
      }
    </ng-template>
    <ng-template pTemplate>
      <p-splitter [panelSizes]="[50, 50]">
        <!--***************************************************************Bottom left Panel*************************************************************************-->
        <ng-template pTemplate>
          <section class="panel">
            @if (showOrderDetail) {
              <app-order-detail [order]="selectedOrder" [rowDataCoil]="rowDataCoil" [hideTitle]="false" (coilSelectionChanged)="onCoilSelectionChanged($event)" (coilNrClicked)="onCoilCellClicked($event)"></app-order-detail>
            } @else {
              <app-coil-detail [coil]="selectedCoil" [order]="selectedOrder" (viewOrderDetail)="this.showOrderDetail = true"></app-coil-detail>
            }
            </section>
        </ng-template>
        <!--***************************************************************Bottom Right Panel*************************************************************************-->
        <ng-template pTemplate>
         
          <section class="panel">
            @if ( selectedCoil){
              @if ( selectedCoil.availableDataSetNames && selectedCoil.availableDataSetNames.length > 0) {
                <app-coil-analytics [coil]="selectedCoil"></app-coil-analytics>
              }
              @else {
                <div class="d-flex justify-content-center align-items-center h-100">
                  <img src="assets/images/no-results.svg" alt="Tata Steel logo" />
                </div>
              }
            }
            @else {
              <div class="d-flex justify-content-center align-items-center h-100">
                <img src="assets/images/no-results.svg" alt="Tata Steel logo" />
              </div>
            }
          </section>
        </ng-template>
      </p-splitter>
    </ng-template>
  </p-splitter>
  <app-disclaimer [(showDisclaimerDialog)]="shouldShowDisclaimer" (showDisclaimerDialogChange)="onDisclaimerAccepted($event)"></app-disclaimer>
  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
</main>
